import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/axios";
import { useSubscription } from "../../contexts/SubscriptionContext";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const { refreshSubscription } = useSubscription();

  useEffect(() => {
    let done = false;
    const run = async () => {
      try {
        await api.post("/api/user/subscription/refresh", {});
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Failed to refresh subscription after billing:", e);
      } finally {
        if (!done) {
          await refreshSubscription();
          navigate("/dashboard/settings", { replace: true });
        }
      }
    };
    run();
    return () => {
      done = true;
    };
  }, [navigate, refreshSubscription]);

  return (
    <div className="w-full py-20 text-center">
      <h2 className="text-2xl font-bold text-gray-900 mb-2">
        Processing your upgrade…
      </h2>
      <p className="text-gray-600">
        One moment while we refresh your subscription.
      </p>
    </div>
  );
}
